import { render } from "./AsRenewCourseMobile.vue?vue&type=template&id=75d305e4&ts=true"
import script from "./AsRenewCourseMobile.vue?vue&type=script&lang=ts"
export * from "./AsRenewCourseMobile.vue?vue&type=script&lang=ts"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__